export default __webpack_public_path__ + "static/media/boutiquePoster.1a33a16d.jpg";